import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import { navbar } from "template/header/headerStatic";
import useLang from "hook/useLang";
import { createLinkBaseOnLang, showNavBarItem } from "tools/tools";
var items = Array.from(Array(4), function (_, i) { return i + 1; });
function ResponsiveHeader(_a) {
    var homePage = _a.homePage, techPage = _a.techPage, mediaPage = _a.mediaPage, worksPage = _a.worksPage, servicesPage = _a.servicesPage, aboutUs = _a.aboutUs, mrEstateInfoPage = _a.mrEstateInfoPage, mrEstateIntroPage = _a.mrEstateIntroPage, mrEstateFeaturesPage = _a.mrEstateFeaturesPage, mrEstateMonetizationPage = _a.mrEstateMonetizationPage;
    var _b = useState(false), show = _b[0], setShow = _b[1];
    var location = useLocation();
    var navRef = useRef();
    var lang = useLang();
    useEffect(function () {
        setShow(false);
    }, [location.key]);
    var navHeight = function () {
        if (navRef && navRef.current) {
            return navRef.current.scrollHeight;
        }
    };
    var burger = classNames({
        'relative z-20 dir-ltr w-8': true,
        'burger-container': show
    });
    var spanClassName = classNames({
        'block relative top-0 w-full h-1 my-1 transition-all duration-300 ease-linear rounded': true,
        'bg-white': homePage || techPage || servicesPage || aboutUs || mediaPage || mrEstateFeaturesPage || mrEstateMonetizationPage,
        'bg-primary': worksPage,
        'bg-mrestate': mrEstateInfoPage || mrEstateIntroPage
    });
    return (React.createElement("div", { className: 'relative sm:hidden' },
        React.createElement("div", { className: burger, onClick: function () { return setShow(function (prevState) { return !prevState; }); } }, items.map(function (item) { return React.createElement("span", { key: item, className: spanClassName }); })),
        show ?
            React.createElement("div", { className: 'fixed z-10 inset-0 w-full h-full', onClick: function () { return setShow(false); } })
            : null,
        React.createElement("ul", { ref: navRef, className: 'absolute overflow-hidden z-20 top-10 rtl:right-0 ltr:left-0 bg-white px-1 rounded shadow-md transition-height duration-300 ease-linear', style: { height: show ? navHeight() : 0 } }, navbar(lang.file).map(function (item) {
            var show = showNavBarItem(location.pathname, item.type);
            if (!show)
                return;
            return (React.createElement("li", { key: item.id },
                React.createElement(Link, { to: createLinkBaseOnLang(location.pathname, item.href) },
                    React.createElement("div", { className: 'text-15 font-medium py-1 px-3 my-1 whitespace-nowrap' }, item.title))));
        }))));
}
export default ResponsiveHeader;
